import React, { useState } from 'react'
import Select from 'react-select'
import DownloadPub from './publications'

// const options = [
//   { label: 'Part 1: The global picture', value: 'part1' },
//   { label: 'Regional overviews', value: 'regions' },
//   {
//     label: 'Part 2: Children and youth in internal displacement',
//     value: 'part2',

//   }
// ]

const SelectReport = ({ options, action }) => {
  const [currVal, newVal] = useState(options[0])
  const handleChange = e => {
    newVal(e)
  }

  let doc = ''

  if (typeof document !== 'undefined') {
    doc = document.body
  }
  return (
    <form>
      <Select
        menuPortalTarget={doc}
        menuPosition='fixed'
        options={options}
        onChange={e => handleChange(e)}
        defaultValue={options[0]}
        styles={{
          menuPortal: provided => ({ ...provided, zIndex: 9999 }),
          menu: provided => ({ ...provided, zIndex: 9999 })
        }}
      />
      <p>
        <DownloadPub name={currVal.value} suffix={action}></DownloadPub>
      </p>
    </form>
  )
}

export default SelectReport
